import { QueryStringItem } from '../../types/QueryStringItem';

type NullableQueryStringItem = QueryStringItem | null;

export const createQueryString = (items: NullableQueryStringItem[]) =>
  items
    .filter(Boolean)
    .map((item) => (item ? `${encodeURIComponent(item.key)}=${encodeURIComponent(item.value)}` : ''))
    .join('&');
